"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionUp = function AccordionUp() {
  return _react2.default.createElement(
    "g",
    { id: "arrow-up" },
    _react2.default.createElement("polygon", { id: "Shape", points: "441.47 404.54 250.01 213.06 58.53 404.54 0 346.01 250.01 96 500 346.01" })
  );
};

exports.default = AccordionUp;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/AccordionUp.js
// module id = 2916
// module chunks = 4